<template>
  <UiModal
    :show="showScore"
    :title="title"
    :empty="isEmpty"
    @close="showScore = false"
  >
    <div class="score-box">
      <div class="gameList-box">
        <ul class="gameList" v-if="matchList && matchList.length !== 0">
          <li
            v-for="(item, key) in matchList"
            :key="key"
            :name="item.matchCode"
            :class="{ active: subMatch === item.matchCode }"
            @click="switchGame(item.matchCode, item.name)"
          >
            <div class="bg-active"></div>
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="score" name="match" v-show="subMatch !== 'all'">
        <ul class="header">
          <li name="rank">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </li>
          <li v-for="(item, key) in header" :key="key" :name="item.key">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <ul class="data-box">
          <div
            class="list-box"
            v-if="
              subFightScore &&
              subFightScore.teamRankInfos &&
              subFightScore.teamRankInfos.length !== 0
            "
          >
            <li
              v-for="(score, key) in subFightScore.teamRankInfos"
              :key="key"
            >
              <ol>
                <li name="rank">
                  <i v-if="key < 3" class="rank-medal" :class="`rank-${key + 1}`"></i>
                  <div class="label-box" v-else>
                    <span class="label-shadow">{{ key + 1 }}</span>
                    <span class="label-text">{{ key + 1 }}</span>
                  </div>
                </li>
                <li v-for="(item, key) in header" :key="key" :name="item.key">
                  <div v-if="item.key !== specialHeader">
                    {{
                      score[item.key] || score[item.key] === 0
                        ? score[item.key]
                        : "-"
                    }}
                  </div>
                  <div class="teamInfo" v-if="item.key === specialHeader">
                    <div
                      class="avatar"
                      :style="{
                        'background-image': `url(${
                          score['avatar'] ? score['avatar'] : ''
                        })`,
                      }"
                    ></div>
                    <div class="name">{{ score["name"] }}</div>
                  </div>
                </li>
              </ol>
            </li>
          </div>
          <UiEmpty
            v-else-if="!subFightScore ||
              !subFightScore.teamRankInfos ||
              (subFightScore.teamRankInfos && subFightScore.teamRankInfos.length === 0)"
            tip="暂无数据"
            :loading="inRequire"
            loadingTip="正在获取最新成绩..."
            hook="px"
          />
        </ul>
      </div>
      <div class="score" name="integral" :class="{ numHook: headerIntegral.length >= 9 }" v-show="subMatch === 'all'">
        <ul class="header">
          <li name="rank">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">排名</span>
              <span class="label-text">排名</span>
            </div>
          </li>
          <li v-for="(item, key) in headerIntegral" :key="key" :name="item.key">
            <!-- <div class="bg"></div> -->
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <ul class="data-box">
          <div
            class="list-box"
            v-if="totalIntegralList && totalIntegralList.length !== 0"
          >
            <li v-for="(score, key) in totalIntegralList" :key="key">
              <ol>
                <li name="rank">
                  <i v-if="score.is_promotion"></i>
                  <div class="label-box" v-else>
                    <span class="label-shadow">
                      {{ score["total"] || score["total"] === 0 ? key + 1 : "-" }}
                    </span>
                    <span class="label-text">
                      {{ score["total"] || score["total"] === 0 ? key + 1 : "-" }}
                    </span>
                  </div>
                </li>
                <li
                  v-for="(item, key) in headerIntegral"
                  :key="key"
                  :name="item.key"
                >
                  <div v-if="item.key !== specialHeader">
                    {{ score[item.key] ? score[item.key] : "-" }}
                  </div>
                  <div class="teamInfo" v-if="item.key === specialHeader">
                    <div
                      class="avatar"
                      :style="{
                        'background-image': `url(${
                          score['avatar'] ? score['avatar'] : ''
                        })`,
                      }"
                    ></div>
                    <div class="name">{{ score["name"] }}</div>
                  </div>
                </li>
              </ol>
            </li>
          </div>
          <UiEmpty
            v-else-if="!totalIntegralList || (totalIntegralList && totalIntegralList.length === 0)"
            tip="暂无数据"
            :loading="inRequire"
            loadingTip="正在获取最新成绩..."
            hook="px"
          />
        </ul>
      </div>
    </div>
  </UiModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import * as api from "@/service/index";
import { useAppStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import UiModal from "@/components/ui-modal.vue";
import UiEmpty from '@/components/ui-empty';

defineProps({
  matchID: {
    type: String,
    default: () => "",
  },
});


const appStore = useAppStore();
const { showPrompt } = usePrompt();

const title = ref(""); // 传递过来的积分表标题
const subMatch = ref("");
const specialHeader = ref("team");
const header = ref([
  { key: "team", name: "战队" },
  { key: "singleRankingPoint", name: "排名分" },
  { key: "totalKillScore", name: "淘汰分" },
  { key: "totalPoint", name: "总积分" },
]);
const headerIntegral = ref([{ key: "team", name: "战队" }]);
const scoreList = ref([]); // 全部对局的成绩
const totalIntegralList = ref([]); // 全部队伍的总积分
const matchList = ref([]); // 右侧对局列表
const showScore = ref(false);
const inRequire = ref(true); // 正在请求数据

const seasonInfo = computed(() => appStore.seasonInfo);
const token = computed(() => appStore.token);
const subFightScore = computed(() => {
  return scoreList.value.find((item) => item.matchCode === subMatch.value);
});
const isEmpty = computed(() => {
  if (subMatch.value === 'all') {
    return !totalIntegralList.value || totalIntegralList.value.length === 0;
  }
  return !subFightScore.value || !subFightScore.value.teamRankInfos || subFightScore.value.teamRankInfos.length === 0;
});

function switchGame(code, name) {
  subMatch.value = code;

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('切换详情局', {
    '#schedule_id': title.value,
    '#match_id': name
  });
}
function initMatchDetail(code, title_) {
  inRequire.value = true;
  resetData();
  title.value = title_;
  let thisSeasonId = seasonInfo.value.id || '';
  if(!token.value) return;
  let data = {
    scheduleCode: code,
    token: token.value,
    seasonId: thisSeasonId
  };
  api.reqMatchDetail(data).then((response) => {
    if (response.status === 200) {
      let matchInfo = response.data;

      // 所有侧边栏对局
      matchList.value = matchInfo.baseMatchLists;
      // 总积分的头部
      let header_ = matchList.value.map((match) => {
        return { key: match.matchCode, name: match.name };
      });
      headerIntegral.value.push.apply(headerIntegral.value, header_);
      // 添加总积分的侧边栏对局
      if (!matchList.value.find((match) => match.matchCode === "all")) {
        matchList.value.unshift({
          matchCode: "all",
          name: "总积分",
        });
      }
      scoreList.value = matchInfo.matchDetailLists;
      totalIntegralList.value = matchInfo.totalIntegral;

      subMatch.value = "all";
    } else {
      showPrompt(response.data);
    }
    inRequire.value = false;
  });

  showScore.value = true;
}
function closeModal() {
  showScore.value = false;

  // 关闭弹窗后，清空数据, 保持数据最新
  scoreList.value = [];
}
function resetData() {
  matchList.value = [];
  scoreList.value = [];
  totalIntegralList.value = [];
  headerIntegral.value = [{ key: "team", name: "战队" }];
}

// 父组件(schedule/index.vue、live/index.vue)通过 $refs.scoreModal.initMatchDetail 调用
defineExpose({ initMatchDetail, closeModal });
</script>
<style lang="scss" scoped>
:deep(.modal__header .title) {
  padding-right: 60px;
  padding-left: 20px;
  .label-box {
    font-size: 22px !important;
    margin-top: 20px !important;
    .label-shadow,
    .label-text {
      white-space: pre-line;
      line-height: 1;
    }
    .label-text {
      color: #000 !important;
    }
  }
}

.score-box {
  box-sizing: border-box;
  padding: 3px 32px 18px 26px;
  width: 100%;
  height: 100%;
  font-weight: 500;
  display: flex;
  justify-content: space-between;

  .gameList-box {
    width: 146px;
    height: 522px;
    background: url(https://website.xdcdn.net/poster/58881/26match/common/PMg7K8ih.png) center/contain no-repeat;
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    padding-top: 8px;
    margin-top: 4px;
    box-sizing: border-box;

    .gameList {
      width: 100%;
      height: 100%;
      font-size: 24px;
      z-index: 1;
      display: flex;
      flex-direction: column;

      li {
        position: relative;
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 116px;
          height: 2px;
          background-color: #C90003;
        }

        .label-box {
          .label-shadow,
          .label-text {
            transition: color ease-in-out 100ms;
          }
          .label-shadow {
            color: #C90003;
          }
        }

        .bg-active {
          position: absolute;
          top: 3px;
          left: -16px;
          width: 167px;
          height: 66px;
          pointer-events: none;
          opacity: 0;
          transition: all ease-in-out 100ms;
          background: url(https://website.xdcdn.net/poster/58881/26match/common/PMf0Au33.png) center/contain no-repeat;
        }

        &:last-child::after {
          display: none;
        }

        &.active {
          &::after {
            display: none;
          }

          .bg-active {
            opacity: 1;
          }

          .label-box {
            .label-shadow {
              color: rgba(#fff, 0.7);
            }
            .label-text {
              color: #513718;
            }
          }
        }
      }
    }
  }

  .score {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 12px;
    width: calc(100% - 12px - 146px);
    height: 100%;
    padding-bottom: 18px;
    box-sizing: border-box;

    .header {
      width: 100%;
      height: 46px;
      font-size: 24px;
      margin-bottom: 6px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      li {
        position: relative;
        flex: 1;
        min-width: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .label-box {
          padding: 0 7px;
          span {
            max-width: 140px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .label-shadow {
            color: #FFFFFF;
          }
          .label-text {
            color: #333333;
          }
        }

        &[name="rank"] {
          flex: 0 0 60px;
          margin-left: 10px;
        }

        &[name="team"] {
          flex: 0 0 170px;
          text-align: center;
        }
      }
    }

    &[name="integral"].numHook .header {
      font-size: 20px;
    }

    // 单场视图: 内容少, rank 列与其他列一起平分, 不占固定宽
    &[name="match"] {
      .header li[name="rank"],
      .data-box .list-box ol > li[name="rank"] {
        flex: 1;
        margin-left: 0;
      }
    }

    .data-box {
      flex: 1;
      position: relative;
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      @include scrollBarIE2();

      .list-box {
        width: 100%;
        font-size: 20px;
        color: $black-66;
        display: flex;
        flex-direction: column;

        >li {
          height: 68px;

          &:nth-child(even) {
            background-color: #FDEEEE;
            mix-blend-mode: multiply;
          }

          ol {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;

            >li {
              flex: 1;
              min-width: 0;
              text-align: center;

              &[name="rank"] {
                flex: 0 0 60px;
                margin-left: 10px;
                font-size: 40px;
                font-weight: bold;
                font-family: NumFont;

                i {
                  display: inline-block;
                  @include sprite_bg('schedule_promotion');
                }

                // 单场视图前三名奖牌
                i.rank-medal {
                  background: center/contain no-repeat;
                  &.rank-1 {
                    width: 68px;
                    height: 62px;
                    background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/PMsmbzly.png);
                  }
                  &.rank-2 {
                    width: 56px;
                    height: 58px;
                    background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/PMsmbhhp.png);
                  }
                  &.rank-3 {
                    width: 48px;
                    height: 58px;
                    background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/PMsmbpim.png);
                  }
                }

                .label-box {
                  .label-shadow {
                    color: #FFFFFF;
                  }
                  .label-text {
                    color: #333333;
                  }
                }
              }

              &[name="team"] {
                flex: 0 0 170px;
                text-align: center;
                color: $black-33;
              }

              .teamInfo {
                display: flex;
                align-items: center;

                .avatar {
                  flex: 0 0 46px;
                  margin-right: 10px;
                  height: 46px;
                  border: 2px solid $white-D;
                  border-radius: 50%;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: cover;
                }

                .name {
                  flex: 1;
                  min-width: 0;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
